module.exports = __webpack_public_path__ + "static/work35-31a58ce3e802fe8196d008d71a41e504.jpg";